/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Placeholder_AddressInputs */

const da_legal_placeholder_address = /** @type {(inputs: Legal_Placeholder_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[adresse]`)
};

/** @type {(inputs: Legal_Placeholder_AddressInputs) => LocalizedString} */
const en_legal_placeholder_address = da_legal_placeholder_address;

/**

* @param {Legal_Placeholder_AddressInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_placeholder_address = /** @type {((inputs?: Legal_Placeholder_AddressInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Placeholder_AddressInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_placeholder_address(inputs)
	return /** @type {LocalizedString} */ ("[adresse]")
});